import React, { FunctionComponent, useCallback } from 'react';

import { onMoveAnimation } from 'services/hooks/useDevelopUI';
import { useAppDispatch } from 'app/store';
import { selectToken } from 'reducers';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useMetamask } from '@thirdweb-dev/react';
import { useWalletConnect } from '@thirdweb-dev/react';
import { useDisconnect } from '@thirdweb-dev/react';
import { useNetwork } from '@thirdweb-dev/react';
import { useAddress } from '@thirdweb-dev/react';
import { useChainId } from '@thirdweb-dev/react';
import { useNetworkMismatch } from '@thirdweb-dev/react';
export const withConnect =
  (WrappedComponent: FunctionComponent) => (props: any) => {
    function useGetSelectQuery() {
      const { search } = useLocation();

      return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useGetSelectQuery();
    const [{ data, error, loading }, switchNetwork] = useNetwork();
    const token = useSelector(selectToken);
    const disconnect = useDisconnect();
    const connectWithMetamask = useMetamask();
    const connectWithWalletConnect = useWalletConnect();
    const account = useAddress();
    const chainId = useChainId();
    const isConnectedCompatibleChain = !useNetworkMismatch();
    const connect = (connector: string) => {
      if (connector === 'injected') {
        connectWithMetamask();
        return;
      }
      if (connector === 'walletconnect') {
        connectWithWalletConnect();
        return;
      }
      return;
    };

    const onOpenConnectModal = useCallback(() => {
      onMoveAnimation('connect-wallet-overlay', 'moveInOpacity');
    }, [onMoveAnimation]);

    const onCloseConnectModal = useCallback(
      () => onMoveAnimation('connect-wallet-overlay', 'moveOutOpacity'),
      [onMoveAnimation],
    );
    const dispatch = useAppDispatch();
    const onCheckBeforeRequest = useCallback(async () => {
      if (!account) {
        onOpenConnectModal();
        return false;
      }
      if (!isConnectedCompatibleChain) {
        switchNetwork?.(parseInt(process.env.REACT_APP_BASE_CHAIN_ID || '280'));
        toast.info('Hmm! Look like you connected incompatible network');
        return false;
      }
      return true;
    }, [token, account, isConnectedCompatibleChain]);

    return (
      <WrappedComponent
        {...{
          ...props,
          connectWithMetamask,
          connectWithWalletConnect,
          account,
          chainId,
          onCloseConnectModal,
          onOpenConnectModal,
          disconnect,
          isConnectedCompatibleChain,
          token,
          onCheckBeforeRequest,
          connect,
        }}
      />
    );
  };

export default withConnect;
